module.exports = __webpack_public_path__ + "img/piraboradobomjesus.8d1320e9.png";